var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('back-to-top-component'),_c('home-header',{attrs:{"onlyShowTop":true}}),_c('img',{attrs:{"src":require("../assets/imgs/img2.jpg")}}),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }